import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  IconButton, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemText,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

// Styled Components
const StyledMobileDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.background.default,
  },
}));

const StyledMobileAppBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '0px',
}));

const StyledMobileTitle = styled(Typography)<{ component?: React.ElementType }>(({ theme }) => ({
  flexGrow: 1,
}));

const StyledMobileDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: 0,
}));

const StyledMobileListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(2, 0),
}));

const StyledMobileButtonContainer = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'center',
}));

const StyledMobileButton = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  padding: theme.spacing(1.5, 4),
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[3],
  '&:hover': {
    boxShadow: theme.shadows[6],
    transform: 'translateY(-2px)',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
}));

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  onOpenBookingDialog: () => void;
  scrollTo: (id: string) => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  open, 
  onClose, 
  onOpenBookingDialog,
  scrollTo 
}) => {
  return (
    <StyledMobileDialog
      fullScreen
      open={open}
      onClose={onClose}
    >
      <StyledMobileAppBar position="relative">
        <Toolbar>
          <StyledMobileTitle 
            variant="h6" 
            component="div"
          >
            Menu
          </StyledMobileTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </StyledMobileAppBar>

      <StyledMobileDialogContent>
        <List>
          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("home")}>
              <ListItemText 
                primary="Home" 
                primaryTypographyProps={{
                  variant: 'body1',
                  fontWeight: 'medium'
                }}
              />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />
          
          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("about")}>
              <ListItemText 
                primary="Over Ons" 
                primaryTypographyProps={{
                  variant: 'body1',
                  fontWeight: 'medium'
                }}
              />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />
          
          <ListItem disablePadding>
            <StyledMobileListItemButton onClick={() => scrollTo("services")}>
              <ListItemText 
                primary="Diensten" 
                primaryTypographyProps={{
                  variant: 'body1',
                  fontWeight: 'medium'
                }}
              />
            </StyledMobileListItemButton>
          </ListItem>
          <Divider />
          
          <StyledMobileButtonContainer disablePadding>
            <StyledMobileButton
              variant="contained"
              color="secondary"
              size="large"
              onClick={() => {
                onOpenBookingDialog();
                onClose();
              }}
            >
              Boek Nu
            </StyledMobileButton>
          </StyledMobileButtonContainer>
        </List>
      </StyledMobileDialogContent>
    </StyledMobileDialog>
  );
};

export default MobileMenu; 